export const ASSETS = {
  "backgrounds": {
    "mainMenu": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/89943b46afbe40eab7ae17f54cdc39c7/main/preview/assets/backgrounds/alien_moon_landscape.png",
      "height": 300,
      "width": 300
    }
  },
  "music": {
    "gameplay": {
      "path": "https://ucarecdn.com/9a2094db-ba1b-4f2e-89d9-32fe05514d40/gameMusic2.mp3",
      "height": 300,
      "width": 300
    },
    "mainMenu": {
      "path": "https://ucarecdn.com/ca8edfa4-b498-476a-9d27-16cf6eeb9595/mainMenu.mp3",
      "height": 300,
      "width": 300
    }
  },
  "sfx": {
    "attackMelee": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/7835e3423f9040918f75789e60403b44/ab21f02a1c05428bbd54ba69febc9b62/preview/assets/sfx/attack_melee.ogg"
    },
    "attackRanged": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/7835e3423f9040918f75789e60403b44/ab21f02a1c05428bbd54ba69febc9b62/preview/assets/sfx/attack_ranged.ogg"
    },
    "baseHit": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/7835e3423f9040918f75789e60403b44/ab21f02a1c05428bbd54ba69febc9b62/preview/assets/sfx/base_hit.ogg"
    },
    "enemyDie": {
      "path": "https://ucarecdn.com/2b716eb3-96b1-44d6-86ce-fc3c6e37ca61/enemyDIe.wav",
      "height": 300,
      "width": 300
    },
    "enemyHit": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/7835e3423f9040918f75789e60403b44/ab21f02a1c05428bbd54ba69febc9b62/preview/assets/sfx/enemy_hit.ogg"
    },
    "gameOver": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/7835e3423f9040918f75789e60403b44/ab21f02a1c05428bbd54ba69febc9b62/preview/assets/sfx/game_over.ogg"
    },
    "menuClick": {
      "path": "https://ucarecdn.com/715ac27c-6a09-4d05-9bc2-b13a5063df27/buttonSelect.wav",
      "height": 300,
      "width": 300
    },
    "menuSelect": {
      "path": "https://ucarecdn.com/b6976a5e-9294-4344-bd92-f6aa15c38d14/button1.wav",
      "height": 300,
      "width": 300
    },
    "mergeTroop": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/7835e3423f9040918f75789e60403b44/ab21f02a1c05428bbd54ba69febc9b62/preview/assets/sfx/merge_troop.ogg"
    },
    "placeTroop": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/7835e3423f9040918f75789e60403b44/ab21f02a1c05428bbd54ba69febc9b62/preview/assets/sfx/place_troop.ogg"
    },
    "upgrade": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/7835e3423f9040918f75789e60403b44/ab21f02a1c05428bbd54ba69febc9b62/preview/assets/sfx/upgrade.ogg"
    },
    "waveStart": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/7835e3423f9040918f75789e60403b44/ab21f02a1c05428bbd54ba69febc9b62/preview/assets/sfx/wave_start.ogg"
    }
  },
  "sprites": {
    "apex_predator": {
      "path": "https://ucarecdn.com/e2fd8bad-fb17-4dac-92b6-499fd87ff842/blue_alien.png",
      "height": 300,
      "width": 300
    },
    "assassin": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1059c412fc00465c85e8a134ebc5c3d4/main/preview/assets/characters/mutant_blue_alien.png",
      "height": 300,
      "width": 300
    },
    "assassin_vanguard": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/f3feb1486cd5447da56897708d766891/main/preview/assets/characters/purple_tentacle_alien.png",
      "height": 300,
      "width": 300
    },
    "base": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/18b75367c40d4d0f9a6950380956d839/main/preview/assets/characters/alien_base.png",
      "height": 300,
      "width": 300
    },
    "base_health_icon": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/934574222917438eba8b9cd07d450586/main/preview/assets/icons/heart.png",
      "height": 300,
      "width": 300
    },
    "battle_ranger": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/a7e24b5d19284da18b021a31035669e8/main/preview/assets/characters/alien_warrior.png",
      "height": 300,
      "width": 300
    },
    "berserker": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/fb3309d7b6034646a35a6e732475cd37/main/preview/assets/characters/purple_tentacle_alien.png",
      "height": 300,
      "width": 300
    },
    "champion": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/e573636fb77443f7a4f4edcbacb8cb5a/main/preview/assets/characters/purple_tentacle_alien.png",
      "height": 300,
      "width": 300
    },
    "champion_warrior": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/d5e8f9a36bb041a4b2aea2c2c636e424/main/preview/assets/characters/alien_warrior.png",
      "height": 300,
      "width": 300
    },
    "combat_marksman": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/0eaf624d7f0248c5857b04c863b8d17d/main/preview/assets/characters/blue_alien.png",
      "height": 300,
      "width": 300
    },
    "commander": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/2fc5c7fb598b475c8f4a2923c4944a43/main/preview/assets/characters/blue_alien_combat.png",
      "height": 300,
      "width": 300
    },
    "crusader": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/8ba7a5ba879b457ab227dba34e8608cf/main/preview/assets/characters/purple_tentacle_alien.png",
      "height": 300,
      "width": 300
    },
    "currency_coin": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/44894cbe72af4765876d435d30aafbeb/main/preview/assets/icons/glowing_blue_crystal.png",
      "height": 300,
      "width": 300
    },
    "death_stalker": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/ac4e5d81e0144c86a3e8e2292f69e716/main/preview/assets/characters/purple_tentacle_alien_sniper.png",
      "height": 300,
      "width": 300
    },
    "deathdealer": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/a7ac90943118426c9409625a186e5bee/main/preview/assets/characters/blue_alien.png",
      "height": 300,
      "width": 300
    },
    "elite_marksman": {
      "path": "https://ucarecdn.com/efb89d7e-838e-4b78-b5e9-339dbae56526/alien_sniper.png",
      "height": 300,
      "width": 300
    },
    "elite_scout": {
      "path": "https://ucarecdn.com/028454b2-ede2-48f0-9569-f2709197a34a/purple_tentacle_alien (1).png",
      "height": 300,
      "width": 300
    },
    "elite_soldier": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/8d7b7d0ca7994e2095a002ae5b36140f/main/preview/assets/characters/blue_tentacle_alien.png",
      "height": 300,
      "width": 300
    },
    "enemy": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/3aba577dd14a46e58874f7593e123f75/main/preview/assets/characters/astronaut_enemy.png",
      "height": 300,
      "width": 300
    },
    "enemy_brute": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/b9c17e4b46834a0e9fd822f5da9f388a/main/preview/assets/characters/lunar_mecha.png",
      "height": 300,
      "width": 300
    },
    "enemy_fast": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/ccf195ae90734f349d054a1b53f9c587/main/preview/assets/characters/lunar_robot.png",
      "height": 300,
      "width": 300
    },
    "enemy_swarm": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/3a1d05c1223548fbb9316bbb7ffa010f/main/preview/assets/characters/lunar_robot.png",
      "height": 300,
      "width": 300
    },
    "enemy_tank": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/6ca4c674597d4c8fa361719dba12a7c6/main/preview/assets/characters/lunar_tank.png",
      "height": 300,
      "width": 300
    },
    "ghost": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/3559bb98b0424ce8a84432cf29599f99/main/preview/assets/characters/purple_tentacle_alien.png",
      "height": 300,
      "width": 300
    },
    "ghost_sniper": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/87bb4a7baff74ff28706e43deafdc202/main/preview/assets/characters/blue_alien_sniper.png",
      "height": 300,
      "width": 300
    },
    "guardian": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/5320ea8ceebb48dcb129843d38d34a07/main/preview/assets/characters/blue_alien.png",
      "height": 300,
      "width": 300
    },
    "heavy_soldier": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/02b46aa8924f42769a2bfc3328196ba5/main/preview/assets/characters/alien_warrior.png",
      "height": 300,
      "width": 300
    },
    "hybrid_commander": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/279abdd33be34a6f9ef325f4f693dc67/main/preview/assets/characters/blue_alien.png",
      "height": 300,
      "width": 300
    },
    "infiltrator": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/02f175042115407684086611fe1aac24/main/preview/assets/characters/tentacle_alien.png",
      "height": 300,
      "width": 300
    },
    "juggernaut": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/da056f0eb26d4c899f2327a6ec3816de/main/preview/assets/characters/purple_tentacle_alien.png",
      "height": 300,
      "width": 300
    },
    "lord_of_war": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/5714cfb502ed4c3f93c05a2e9fcd7d32/main/preview/assets/characters/tentacle_alien.png",
      "height": 300,
      "width": 300
    },
    "marksman_elite": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/a67f4ec44c794cd4923ad24ec2a19c14/main/preview/assets/characters/purple_tentacle_alien.png",
      "height": 300,
      "width": 300
    },
    "master_sniper": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/7d00208542b644239f78f76a6281f087/main/preview/assets/characters/alien_sniper.png",
      "height": 300,
      "width": 300
    },
    "melee": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/9f720a8121184415a84669d9951889b9/ed4e01d1ead244258d2f3426f9a4b817/preview/assets/characters/blue_alien_topdown.png",
      "height": 300,
      "width": 300
    },
    "pathfinder": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/25d23facd772468f8971d6ae7c93fac4/main/preview/assets/characters/tentacle_alien.png",
      "height": 300,
      "width": 300
    },
    "phantom": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/baf1618d31bc4941a91566650c1369d0/main/preview/assets/characters/purple_tentacle_alien.png",
      "height": 300,
      "width": 300
    },
    "phantom_soldier": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/fe8df55edb9a42c192f9464144b80912/main/preview/assets/characters/alien_sniper.png",
      "height": 300,
      "width": 300
    },
    "phantom_vanguard": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/00eab9655eee49359bf7797b19273415/main/preview/assets/characters/purple_tentacle_alien.png",
      "height": 300,
      "width": 300
    },
    "precision_killer": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/1179673dcfc7406c885090e12fbda781/main/preview/assets/characters/blue_alien_strong.png",
      "height": 300,
      "width": 300
    },
    "projectile": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/92756f03b7df4791a7623c2b0c32910e/main/preview/assets/projectile.png",
      "height": 12,
      "width": 12
    },
    "ranger": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/fe9dd62046964ec8a1ece3c88d13a57b/main/preview/assets/characters/purple_tentacle_alien.png",
      "height": 300,
      "width": 300
    },
    "ranger_assassin": {
      "path": "https://ucarecdn.com/e7156bb7-c3e7-4ed9-8620-7fff5d8ee2f9/alien_warrior (1).png",
      "height": 300,
      "width": 300
    },
    "ranger_leader": {
      "path": "https://ucarecdn.com/f526109e-cba6-4477-9f31-8617fddf2f2b/purple_tentacle_alien (2).png",
      "height": 300,
      "width": 300
    },
    "ranger_marksman": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/17e35432386a45809456fa7fd01c40ca/main/preview/assets/characters/alien_warrior.png",
      "height": 300,
      "width": 300
    },
    "recon_specialist": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/15cceeeb5e404f75aa892209d3e50e7c/main/preview/assets/characters/tentacle_alien.png",
      "height": 300,
      "width": 300
    },
    "scout": {
      "path": "https://ucarecdn.com/33a9c59a-f972-4998-bf84-eff63b4cb23d/purple_tentacle_alien.png",
      "height": 300,
      "width": 300
    },
    "scout_commander": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/607788537876499fba0303620261d42a/main/preview/assets/characters/purple_tentacle_alien.png",
      "height": 300,
      "width": 300
    },
    "shadow_assassin": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/bab9caa7eac44395939a028bf6336cf9/main/preview/assets/characters/alien_sniper.png",
      "height": 300,
      "width": 300
    },
    "shadow_hunter": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/db264e86dcbf41e98cfbc5358128eafa/main/preview/assets/characters/purple_tentacle_alien.png",
      "height": 300,
      "width": 300
    },
    "sniper": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/9f720a8121184415a84669d9951889b9/f8d97f6f2e4c4d349d46525b467ecb92/preview/assets/characters/blue_alien_topdown.png",
      "height": 300,
      "width": 300
    },
    "sniper_commander": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/330ce27a4a174deb8dabfb1c2dcd5400/main/preview/assets/characters/blue_alien_warrior.png",
      "height": 300,
      "width": 300
    },
    "sniper_melee": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/877028201ef4431cbe0948fd03368be2/main/preview/assets/characters/alien_warrior.png",
      "height": 300,
      "width": 300
    },
    "soldier": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/9f720a8121184415a84669d9951889b9/main/preview/assets/characters/blue_alien_topdown.png",
      "height": 300,
      "width": 300
    },
    "soldier_melee": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/b6977ec73c9e49e7a67a6915f7dcee7a/main/preview/assets/characters/alien_warrior.png",
      "height": 300,
      "width": 300
    },
    "soldier_sniper": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/bd2f3a9c3be94be38e16d6fdb3af1087/main/preview/assets/characters/alien_warrior.png",
      "height": 300,
      "width": 300
    },
    "spectral_commander": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/62280fc70ce643989e0096acc396a8a0/main/preview/assets/characters/alien_sniper.png",
      "height": 300,
      "width": 300
    },
    "spectre": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/6374337c22cb49d78bfe9a69ed260b8d/main/preview/assets/characters/purple_tentacle_alien.png",
      "height": 300,
      "width": 300
    },
    "stalker": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/2d7235b50d9048b6b22fb094b56a74f2/main/preview/assets/characters/purple_tentacle_alien.png",
      "height": 300,
      "width": 300
    },
    "tactical_assassin_elite": {
      "path": "https://ucarecdn.com/ecb4fc28-20bf-41b3-9f26-51fd51435337/blue_alien_warrior.png",
      "height": 300,
      "width": 300
    },
    "tile1": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/644b4e1b11cb4e0cb0ff261294453e3a/main/preview/assets/tiling_backgrounds/moon_dirt_tile_2.png",
      "height": 300,
      "width": 300
    },
    "tile2": {
      "path": "https://ucarecdn.com/9ae06d24-b390-4b4a-aa2d-fb384d68c14b/tileV2_2.png",
      "height": 300,
      "width": 300
    },
    "tile3": {
      "path": "https://ucarecdn.com/e43d69d1-391c-4eae-bb26-088ddc691fa0/tileV2_3.png",
      "height": 300,
      "width": 300
    },
    "tile4": {
      "path": "https://ucarecdn.com/7117c6df-2dca-423b-ae34-4c02fc3c49c9/tileV2_4.png",
      "height": 300,
      "width": 300
    },
    "title_logo": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/2822db8d6c804e9684235f08961036a7/main/preview/assets/other/xenomerge_logo.png",
      "height": 300,
      "width": 300
    },
    "splash_logo": {
      "path": "https://ucarecdn.com/e7a36776-9549-4aaa-ba47-8e4867893d78/graph_drk.svg",
      "height": 300,
      "width": 300
    },
    "troop_count_icon": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/69a96eebe25142b38777841d9ca92522/main/preview/assets/icons/blue_alien_head.png",
      "height": 300,
      "width": 300
    },
    "vanguard": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/4f44b3981d394a40828f46f2adba8d9d/main/preview/assets/characters/purple_tentacle_alien.png",
      "height": 300,
      "width": 300
    },
    "vanguard_sniper": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/63df5e25a16d4442a76c994a5d2a636a/main/preview/assets/characters/blue_tentacle_alien.png",
      "height": 300,
      "width": 300
    },
    "war_machine": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/2274556333b3455083c7973a7903142a/main/preview/assets/characters/blue_alien.png",
      "height": 300,
      "width": 300
    },
    "warlord": {
      "path": "https://ucarecdn.com/5ac05d5c-3171-4188-9f87-16c4a60ac69c/blue_alien (1).png",
      "height": 300,
      "width": 300
    },
    "wave_icon": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/6ca4c674597d4c8fa361719dba12a7c6/main/preview/assets/characters/lunar_tank.png",
      "height": 300,
      "width": 300
    },
    "wraith": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/fccaba395fbc4dd68eabddf1558ad8ae/main/preview/assets/characters/purple_tentacle_alien.png",
      "height": 300,
      "width": 300
    }
  }
};
